exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".quote-for h3{background-color:#4b4b4b;border-radius:6px;font-size:1.5rem;font-weight:300;color:#fff;padding:.75rem}.quote-for h3 .float-right-class{float:right !important;font-size:16px;vertical-align:middle;font-weight:500;margin-top:4.5px}.quote-for h3 .float-right-svg{float:right !important;font-size:22px;vertical-align:middle;font-weight:500}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Product/ABLTC/RequestIllustration/SubComponents/QuoteFor.scss
// module id = 7583
// module chunks = 101